import { Avatar } from '@/components/Avatar'
import {
  SplitViewSidebarListItem,
  SplitViewSidebarListItemArrow,
  SplitViewSidebarListItemTitle,
  SplitViewSidebarListItemSubtitle,
} from '@/components/SplitView/SplitViewSidebarListItem'

export interface TeamItemProps {
  to: string
  active?: boolean
  name: string
  avatar: string | null | undefined
  ownerName: string
}

export function TeamItem({
  to,
  active,
  name,
  avatar,
  ownerName,
}: TeamItemProps) {
  return (
    <SplitViewSidebarListItem
      to={to}
      active={active}
      extras={<SplitViewSidebarListItemArrow />}
      visual={
        <Avatar
          size={32}
          subject={{
            avatar,
            displayName: name,
          }}
        />
      }
    >
      <SplitViewSidebarListItemTitle>{name}</SplitViewSidebarListItemTitle>
      <SplitViewSidebarListItemSubtitle>
        Owner: {ownerName}
      </SplitViewSidebarListItemSubtitle>
    </SplitViewSidebarListItem>
  )
}
